import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
interface ButtonProps {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
  icon?: boolean;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
}
export function Button({
  variant = 'primary',
  size = 'md',
  children,
  onClick,
  href,
  className = '',
  icon = false,
  type = 'button',
  disabled = false
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold uppercase tracking-wide transition-all duration-200 ease-in-out rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-black disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-[#D4FF00] text-black hover:bg-[#c4ef00] hover:scale-105 hover:shadow-lg hover:shadow-[#D4FF00]/30 focus:ring-[#D4FF00]',
    secondary: 'bg-red-600 text-white hover:bg-red-700 hover:scale-105 hover:shadow-lg hover:shadow-red-600/30 focus:ring-red-600',
    outline: 'border-2 border-[#D4FF00] text-[#D4FF00] hover:bg-[#D4FF00] hover:text-black focus:ring-[#D4FF00]'
  };
  const sizes = {
    sm: 'px-5 py-2.5 text-xs',
    md: 'px-8 py-4 text-sm',
    lg: 'px-10 py-5 text-base'
  };
  const combinedClasses = `${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`;
  const content = <>
      {children}
      {icon && <ArrowRight className="ml-2 h-4 w-4" data-id="element-16" />}
    </>;
  if (href) {
    const isExternal = href.startsWith('http') || href.startsWith('mailto:');
    if (isExternal) {
      return <a href={href} className={combinedClasses} target="_blank" rel="noopener noreferrer" data-id="element-17">
          {content}
        </a>;
    }
    return <Link to={href} className={combinedClasses} data-id="element-18">
        {content}
      </Link>;
  }
  return <button type={type} onClick={onClick} className={combinedClasses} disabled={disabled} data-id="element-19">
      {content}
    </button>;
}